export default __webpack_public_path__ + "static/media/offered-flight-management.88d69236.svg";